exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".info-container[data-v-9ecda746]{margin-top:5px}.info-border[data-v-9ecda746]{border-bottom:1px solid #dee2e6}", "", {"version":3,"sources":["F:/1.前端/ykb-weixin/src/views/user/personal-data.vue"],"names":[],"mappings":"AACA,iCACE,cAAe,CAChB,AACD,8BACE,+BAAiC,CAClC","file":"personal-data.vue","sourcesContent":["\n.info-container[data-v-9ecda746]{\n  margin-top:5px;\n}\n.info-border[data-v-9ecda746]{\n  border-bottom: 1px solid #dee2e6;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-9ecda746","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/user/personal-data.vue
// module id = 452
// module chunks = 36